import { Component, ViewChild } from '@angular/core';
import { LazyLoadEvent } from 'primeng/api';
import { AccountService } from 'src/app/core/services/account.service';
import { BillingService } from 'src/app/core/services/billing.service';
import { InvoiceService } from 'src/app/core/services/invoice.service';
import { ToastService } from 'src/app/core/services/toast.service';
import { Table } from 'primeng/table';
import { FilterValues } from 'src/app/shared/components/filter/filter.component';



@Component({
    selector: 'app-billing',
    templateUrl: './billing.component.html',
    styleUrl: './billing.component.scss',
    standalone: false
})
export class BillingComponent {

  planNote: string = '';
  selectedPaymentMode: string = 'COD';
  planDetails: any = {};
  selectedPlan: any = {};
  billHistory: any[] = [];
  plans: any[] = [];
  paymentMethod: any = ['COD', 'Online'];
  loading: boolean = false;
  showModal: boolean = false;
  isPlanFeatures: boolean = false;
  isEnable: boolean = false;
  customerOrders: any = [];
  customerProfile: any = {};

  constructor(
    private billingService: BillingService,
    private toastService: ToastService,
    private invoice: InvoiceService,
    private accountService: AccountService
  ) { }

  ngOnInit() {
    this.getSubscription();
    this.getCustomerProfile();
  }

  getBillHistory() {
    this.billingService.getBillHistory().subscribe((res: any) => {
      this.billHistory = res;
    });
  }

  getPlans() {
    this.billingService.getPlans().subscribe((res: any) => {
      this.plans = res.filter((plan: any) => plan.name != 'Starter' && plan?.isActive);
      // this.isPlanFeatures = Object.keys(this.getPlanFeatures()).length ? true : false;
    });
  }

  getPlanFeatures() {
    return this.plans.find((plan) => plan.name === this.planDetails?.planName);
  }

  getSubscription() {
    this.loading = true;
    this.billingService.getSubscriptions().subscribe((res: any) => {
      this.loading = false;
      this.planDetails = res;
      this.getPlans();
      this.getCustomerOrders({
        first: 0,
        rows: this.rows
      } as LazyLoadEvent);
    },
      () => {
        this.loading = false;
      });
  }

  getStatusClass(status: string): string {
    switch (status) {
      case 'Completed':
        return 'border-success text-success bg-success-subtle';
      case 'Pending':
        return 'border-warning text-warning bg-warning-subtle';
      case 'Cancelled':
        return 'border-danger text-danger bg-danger-subtle';
      default:
        return 'border-secondary text-secondary bg-secondary-subtle';
    }
  }

  getCustomerProfile() {
    this.accountService.getCustomerProfile().subscribe({
      next: (res: any) => {
        this.customerProfile = res;
      },
      error: () => {}
    });
  }

  downloadInvoice(order: any) {
    if (!order.invoiceNumber) {
      this.toastService.showToaster(
        'Invoice Not Available',
        'Your invoice is being generated. Please try again shortly.',
        'info'
      );
      return;
    }

    if (!this.customerProfile) {
      this.toastService.showToaster(
        'Profile Incomplete',
        'Customer details are required to generate the invoice.',
        'info'
      );
      return;
    }

    this.invoice.getInvoiceTemplate(this.customerProfile, order);
  }

  getCustomerOrders(event: LazyLoadEvent) {
    if (!this.planDetails?.customerId) return;
    Promise.resolve().then(() => this.loading = true);
    const first = event?.first ?? 0;
    const rows = event?.rows ?? this.rows;
    const page = first / rows + 1;
    let startDate: string | null = null;
    let endDate: string | null = null;

    if (this.rangeDates && this.rangeDates.length === 2) {
      startDate = this.formatDate(this.rangeDates[0]);
      endDate = this.formatDate(this.rangeDates[1]);
    }

    const queryParams: any = {
      page: page,
      limit: rows,
      search: this.searchText,
      status: this.selectedStatus,
      startDate: startDate,
      endDate: endDate
    };

    this.billingService.getCustomerOrders(this.planDetails?.customerId, queryParams).subscribe(
      (res: any) => {
        this.loading = false;
        this.customerOrders = res?.data || [];
        this.totalRecords = res?.totalCount || 0;
      },
      (err) => {
        this.loading = false;
      }
    );
  }

  formatDate(date: Date): string {
    if (!date) return '';
    const y = date.getFullYear();
    const m = (date.getMonth() + 1).toString().padStart(2, '0');
    const d = date.getDate().toString().padStart(2, '0');
    return `${y}-${m}-${d}`;
  }


  get hasPlanDetails(): boolean {
    return this.planDetails && Object.keys(this.planDetails).length > 0;
  }

  generateTransactionId(): string {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';

    const timePart = Date.now().toString(36).toUpperCase();
    const randomPart = Array.from(
      crypto.getRandomValues(new Uint8Array(10)),
      x => chars[x % chars.length]
    ).join('');

    return `TXN-${(timePart + randomPart).slice(0, 10)}`;
  }


  upgradePlan() {
    if (this.loading) return;
    const plan = {
      customerId: this.planDetails?.customerId,
      planId: this.selectedPlan?._id,
      amount: this.selectedPlan?.price,
      planName: this.selectedPlan.name,
      currency: "INR",
      paymentMethod: this.selectedPaymentMode,
      transactionId: this.generateTransactionId(),
      notes: this.planNote
    }

    this.loading = true;

    this.billingService.createPlan(plan).subscribe((res: any) => {
      this.loading = false;
      this.getSubscription();
      this.showModal = false
      this.toastService.showToaster(
        "Upgrade Plan",
        "Your plan has been upgraded successfully.",
        "success"
      );
    },
      (err) => {
        this.loading = false;
        this.showModal = false;
      });
  }

  selectPlan(plan: any) {
    this.selectedPlan = plan;
    this.isEnable = true;
  }

  openModal() {
    this.showModal = true;
  }


  closeModal() {
    this.showModal = false;
    this.selectedPlan = {}
  }

  totalRecords = 0;
  rows = 10;
  searchText: any = '';
  selectedStatus: any = '';
  rangeDates: Date[] | null = null;
  @ViewChild('dt') table!: Table;


  statusOptions = [
    { label: 'All', value: '' },
    { label: 'Pending', value: 'Pending' },
    { label: 'Completed', value: 'Completed' },
    { label: 'Cancelled', value: 'Cancelled' },
  ];
  onFilterChange(values: FilterValues) {
    this.searchText = values.search;
    this.selectedStatus = values.status;
    this.rangeDates = values.dateRange;
    this.table.reset();
  }



}
